import { ReactNode } from "react";

import { SelectData } from "../../../models";
import { Autocomplete } from "../Autocomplete";
import { ADD_NEW_COMPANY_KEY, useCompanyPicker } from "./useCompanyPicker";

export interface CompanyPickerProps {
  label?: string;
  placeholder?: string;
  initialKey?: string | null;
  initialValue?: string | null;
  data: SelectData;
  loading?: boolean;
  disabled?: boolean;
  tooltip?: ReactNode;
  addNewCompanyLabel?: string;
  variant?: "hub" | "seed";
  onTypeSearch: (term: string) => void;
  onSelect: (collaboratorUuid: string) => void;
  onAddNewCompany: (currentSearchTerm: string) => void;
}

export const CompanyPicker = ({
  label,
  placeholder = "Search companies",
  initialKey,
  initialValue,
  data,
  loading,
  disabled,
  tooltip,
  addNewCompanyLabel = "Add new company",
  variant = "seed",
  onTypeSearch,
  onSelect,
  onAddNewCompany,
}: CompanyPickerProps): JSX.Element => {
  const { optionsData, handleChange, handleSelect } = useCompanyPicker({
    data,
    addNewCompanyLabel,
    onSelect,
    onAddNewCompany,
  });

  return (
    <Autocomplete
      className="CompanyPicker"
      label={label}
      placeholder={placeholder}
      initialKey={initialKey}
      initialValue={initialValue}
      data={optionsData}
      alwaysVisibleKey={ADD_NEW_COMPANY_KEY}
      disabled={disabled}
      loading={loading}
      tooltip={tooltip}
      corners={variant === "seed" ? "rounded" : "default"}
      onChange={handleChange}
      onSelect={handleSelect}
      onTypeSearch={onTypeSearch}
    />
  );
};
